<template>
  <card :title="title" id="details" v-if="canEdit || canDelete">
    <span class="action_buttons">
      <img src="~@/assets/images/desktop/icons/controls/plus.svg" class="icon-svg" :title="$t('common.create_new', { name: name })" @click="newObject()"/>
    </span>
    <div class="row">
      <div class="form-group col-sm-12 col-lg-8 text-left">
        <label class="control-label">{{ name+' '+$t('common.name') }}</label>
        <input type="text" v-model="data.name" :placeholder='$t("common.name")'
               :class="{ 'field-error' : this.$v.data.name.$error }"
               class="form-control"/>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-12 col-lg-3 text-left">
        <label class="control-label">{{ $t('salary_calculator.shift.name') }}</label>
        <b-form-select
          v-model="data.shift_uuid"
          class="form-control"
          :options="shift_list"></b-form-select>
      </div>
    </div>
    <agro-action-buttons
      :data="data"
      :can-edit="canEdit"
      :can-delete="canDelete"
      @onSave="save"
      @onSaveAndNew="saveAndNew"
      :save-and-new="true"
      @onDelete="confirmDelete"
      @onGotoList="gotoList"
    ></agro-action-buttons>
  </card>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import {buildDefaultDropdownList, only_price} from '@/helpers/common'
import required from "vuelidate/src/validators/required";
import * as actions from '@/helpers/generalActions'
import {canDelete, canEdit, permissions, permissionTypes} from "@/helpers/Permissions";
import DatePicker2 from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Forbidden from "@/pages/errors/Forbidden";
import AgroActionButtons from "@/components/AgroActionButtons/index";

export default {
  name: 'SCEmployeeRoleDetails',
  data() {
    return {
      data: {},
      backPath: undefined,
    }
  },
  components: {
    AgroActionButtons,
    Forbidden,
    DatePicker2,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'user/users',
      employeeRoles: 'scEmployeeRole/scEmployeeRoles',
      shifts: 'scShift/scShifts'
    }),
    name() {
      return this.$t('salary_calculator.employee_role.title')
    },
    config() {
      return {
        permission: permissions.SC_EMPLOYEE_ROLE,
        permission_type: permissionTypes.module,
        get: this.get,
        create: this.create,
        update: this.update,
        delete: this.delete,
        list_url: '/salary-calculator/sc-employee-role',
        confirm_delete: true,
      }
    },
    actions() {
        return actions;
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    title() {
      return (this.data.uuid ? this.$t('common.edit') : this.$t('common.new'))+' '+this.name;
    },
    shift_list() {
      return buildDefaultDropdownList(this.shifts);
    },
  },
  methods: {
    ...mapActions({
      get: 'scEmployeeRole/getSCEmployeeRole',
      create: 'scEmployeeRole/createSCEmployeeRole',
      update: 'scEmployeeRole/updateSCEmployeeRole',
      delete: 'scEmployeeRole/deleteSCEmployeeRole',
      getShifts: 'scShift/getSCShifts',
    }),
    onlyPrice(event) {
      return only_price(event);
    },
    loadData() {
      let vm = this;
      return this.actions.getData(this, (data) => {
        vm.$set(vm.data, 'shift_uuid', null);
      });
    },
    gotoList() {
      return actions.gotoList(this);
    },
    confirmDelete() {
      return this.actions.confirmDelete(this);
    },
    save() {
      return this.actions.save(this, this.config.list_url);
    },
    saveAndNew() {
      return this.actions.saveAndNew(this, 'add');
    },
    newObject() {
      return this.actions.newObject(this);
    }
  },
  mounted() {
    this.getShifts();
    this.loadData();
    this.actions.handleParams(this);
  },
  watch: {
    $route: {
      handler: function(newVal) {
        this.actions.handleParams(this);
      },
      deep: true,
    },
    permission: {
      handler: function(newVal) {
        this.permissionModule = newVal;
      },
      deep: true,
    }
  },
  validations(){
    let vm = this;
    return {
      data: {
        name: {
          required,
        },
      }
    }
  }
}
</script>
